import React from 'react';
import { Box, BoxProps } from '@mui/material';

/**
 * Container Props
 */
export interface ContainerProps extends BoxProps {
  /** Children (optional for self-closing elements like dots, spacers) */
  children?: React.ReactNode;
}

/**
 * Container - Atomic container component
 * 
 * Provides a consistent container abstraction over MUI Box.
 * Use this in domain components and widgets instead of MUI Box directly.
 * 
 * @example
 * ```tsx
 * <Container sx={{ p: 2, mt: 1 }}>
 *   <Content />
 * </Container>
 * ```
 */
export function Container({
  children,
  ...boxProps
}: ContainerProps) {
  return (
    <Box {...boxProps}>
      {children}
    </Box>
  );
}

export default Container;
